var _path, _rect, _rect2, _rect3, _path2, _rect4, _rect5, _rect6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivityConversation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    title: "conversation",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9995 27.4467C28.9994 29.1035 27.6563 30.4466 25.9995 30.4466L25.3638 30.4466L25.3638 34.5L21.0606 30.4466L12.0001 30.4466C10.3432 30.4466 9.00005 29.1034 9.00011 27.4465L9.00053 15.9999C9.00059 14.3431 10.3437 13 12.0005 13L25.9999 13C27.6568 13 29 14.3432 28.9999 16.0001L28.9995 27.4467Z",
    fill: "#E1E9F8",
    stroke: "#285FCB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    transform: "matrix(-1 0 0 1 26 21)",
    fill: "#3F70D0",
    fillOpacity: 0.26
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 2,
    transform: "matrix(-1 0 0 1 26 17)",
    fill: "#3F70D0",
    fillOpacity: 0.26
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    transform: "matrix(-1 0 0 1 21 25)",
    fill: "#3F70D0",
    fillOpacity: 0.26
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00052 14.6519C1.00059 16.3087 2.34371 17.6518 4.00052 17.6518L4.63584 17.6518L4.63584 21L8.93846 17.6518L18.9999 17.6518C20.6568 17.6518 22 16.3086 21.9999 14.6517L21.9995 3.99812C21.9994 2.34131 20.6563 0.998237 18.9995 0.998238L4.00011 0.998243C2.34321 0.998243 1.00005 2.34146 1.00011 3.99836L1.00052 14.6519Z",
    fill: "white",
    stroke: "#285FCB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 8,
    width: 15,
    height: 2,
    fill: "#EEF1F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 15,
    height: 2,
    fill: "#EEF1F4"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 12,
    width: 9,
    height: 2,
    fill: "#EEF1F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityConversation);
export default __webpack_public_path__ + "static/media/activityConversation.9461ac8a.svg";
export { ForwardRef as ReactComponent };